<template>
  <div class="config-view">
    <h6>Valeurs RVB ou CMJN</h6>

    <div 
      class="apercu" 
      :style="{ background: `rgb(${r}, ${g}, ${b})` }"
    ></div>

    <p class="m-top-5">CMJN (en %)</p>
    
    <label class="m-right-5">C</label>
    <input placeholder="Cyan (%)" v-model="c" type="number" step="1" min="0" max="100">
    <br>
    <label class="m-right-5">M</label>
    <input placeholder="Magenta (%)" v-model="m" type="number" step="1" min="0" max="100">
    <br>
    <label class="m-right-7">J</label>
    <input placeholder="Jaune (%)" v-model="y" type="number" step="1" min="0" max="100">
    <br>
    <label class="m-right-5">N</label>
    <input placeholder="Noir (%)" v-model="k" type="number" step="1" min="0" max="100">

    <p class="m-top-5">Valeurs RGB</p>

    <label class="m-right-5">R</label>
    <input placeholder="Rouge" v-model="r" type="number" step="1" min="0" max="255">
    <br>
    <label class="m-right-5">V</label>
    <input placeholder="Vert" v-model="g" type="number" step="1" min="0" max="255">
    <br>
    <label class="m-right-5">B</label>
    <input placeholder="Bleu" v-model="b" type="number" step="1" min="0" max="255">

    <button @click="saveRgb">
      Valider en RGB ou CMJN
    </button>

    <hr class="margin-vertical-10">

    <h6>Valeur hexadécimale</h6>

    <input placeholder="Valeur" v-model="hexa">

    <div class="apercu" :style="{ background: hexa }"></div>

    <button @click="saveHexa">
      Valider en hexa
    </button>
  </div>
</template>

<script>
  import { reactive, toRefs, watch } from 'vue'

  export default {
    setup () {

      const state = reactive({
        hexa: '#195C2A',
        r: 255,
        g: 0,
        b: 0,
        c: 21,
        m: 87,
        y: 79, 
        k: 13, 
      })

      watch(() => [state.c, state.m, state.y, state.k], ([c, m, y, k]) => {
        state.r = parseInt(255 * (1 - (c / 100)) * (1 - (k / 100)))
        state.g = parseInt(255 * (1 - (m / 100)) * (1 - (k / 100)))
        state.b = parseInt(255 * (1 - (y / 100)) * (1 - (k / 100)))
      }, { immediate: true })

      function saveRgb () {
        document.documentElement.style.setProperty('--color', `rgb(${state.r}, ${state.g}, ${state.b})`)
        window.alert('Sauvegardé')
        window.localStorage.setItem('color', `rgb(${state.r}, ${state.g}, ${state.b})`)
      }

      function saveHexa () {
        document.documentElement.style.setProperty('--color', state.hexa)
        window.alert('Sauvegardé')
        window.localStorage.setItem('color', state.hexa)
      }

      function reload () {
        window.location = window.location.origin
      }

      return {
        ...toRefs(state),
        saveRgb,
        saveHexa,
        reload,
      }
    },
  }
</script>

<style lang="scss">
  .config-view {
    position: relative;
    height: 100%;
    padding: 0 50px;

    .apercu {
      position: relative;
      height: 50px;
      width: 100%;
    }
  }
</style>